<template>
    <div
        class="c-row settlement-preview pb-2"
        :class="{ 'downloaded-tab': data.downloaded }"
    >
        <div class="c-tr typo-name settlement-preview__topBar">
            <div v-if="!isMPSettlement" class="settlement-preview__sysNo">
                {{ setSettlementId }}
            </div>
            <div v-if="!isMPSettlement" class="settlement-preview__nipNo">
                <span v-tooltip="setNipTooltipLabel">
                    Firma: {{ data.nip }}
                </span>
            </div>
            <div
                class="d-flex align-items-center settlement-preview__paidStatus"
                v-if="isBillingTypeSettlement"
            >
                <a-icon
                    class="mr-1"
                    :icon="data.paid ? 'Success' : 'Warning'"
                    :style="{ color: data.paid ? '#00B300' : '#ffc41a' }"
                />
                <strong v-text="settlementStatus" />
            </div>
        </div>
        <div class="c-tr pt-2">
            <div v-if="showSettlementDetails || isMPSettlement" class="c-td is-4">
                <div class="typo-name text-uppercase">Nr dokumentu</div>
                <span class="font-weight-bold">{{ data.title }}</span>
            </div>
            <!-- TODO: Company hidden in #501 -->
            <!-- <div class="c-td is-1">
                <div class="typo-name text-uppercase">Organizator</div>
                <div class="c-fig c-fig--logo">
                    <img
                        :src="data.company.logo.urls.small"
                        class="c-fig__img"
                        alt
                    />
                </div>
            </div> -->
            <div v-if="showSettlementDetails" class="c-td is-2">
                <div class="typo-name text-uppercase">Data dokumentu</div>
                <div>
                    <span>
                        <strong v-text="$moment(data.sale_date).format('DD-MM-YYYY')" />
                    </span>
                </div>
            </div>
            <div
                v-if="
                    (showSettlementDetails || isMPSettlement) &&
                        data.parametrization &&
                        data.parametrization.document_type_name
                "
                class="c-td"
                :class="
                    `${
                        isBillingTypeSettlement
                            ? 'is-3'
                            : data.updated_at && data.downloaded
                                ? 'is-2'
                                : ''
                    }`
                "
            >
                <div class="typo-name text-uppercase">Typ dokumentu</div>
                <span class="font-weight-bold">{{ documentTypeName }}</span>
            </div>
            <div v-if="isBillingTypeSettlement" class="c-td is-1">
                <div class="typo-name text-uppercase">Okres rozliczeniowy</div>
                <div>
                    <span>
                        <strong>
                            {{ $moment(data.start_at).format('DD-MM-YYYY') }} -
                            {{ $moment(data.end_at).format('DD-MM-YYYY') }}
                        </strong>
                    </span>
                </div>
            </div>
            <div v-if="isBillingTypeSettlement" class="c-td is-5">
                <div class="typo-name text-uppercase">Kwota</div>
                <div class="notesTable-ranges">
                    <span class="typo--xl mr-2">
                        <strong>
                            {{ (+data.amount_net).toFixed(2) }} zł
                        </strong>
                    </span>
                </div>
            </div>
            <div v-if="data.updated_at && data.downloaded && !isMPSettlement" class="c-td is-1">
                <div
                    class="typo-name text-uppercase pr-3"
                    style="white-space: nowrap"
                >
                    Data pobrania
                </div>
                <span class="font-weight-bold">
                    {{ $moment(data.updated_at).format('DD-MM-YYYY') }}
                </span>
            </div>
            <div
                class="
                    d-flex
                    flex-grow-1
                    align-items-center
                    flex-wrap
                "
                :class="{ 'mb-2': data.downloaded }"
            >
                <div
                    class="
                        c-td d-flex flex-wrap py-0
                        justify-content-sm-end justify-content-around
                    "
                >
                    <button
                        v-if="isBillingTypeSettlement"
                        @click="downloadReport"
                        class="btn btn-outline-secondary-dark mb-sm-0 mb-2"
                        :class="{
                            disabled: !data.ready_to_share_report
                        }"
                        v-tooltip="{
                            content: downloadSettlementReportButtonTooltip
                        }"
                    >
                        <a-icon
                            v-if="downloadStatusReport !== 'loading'"
                            icon="Xls"
                            class="mr-2"
                        />
                        <button-spinner
                            class="mr-3 my-1"
                            v-else
                            :status="downloadStatusReport"
                        />
                        Raport rozliczeniowy
                    </button>
                    <button
                        @click="downloadPdf"
                        class="btn btn-outline-secondary-dark mb-sm-0 mb-2 ml-0 ml-sm-4"
                        :class="{
                            disabled: !data.ready_to_share_document
                        }"
                        v-tooltip="{
                            content: downloadSettlementPdfButtonTooltip
                        }"
                    >
                        <a-icon
                            icon="Pdf"
                            class="mr-2"
                            v-if="downloadStatus !== 'loading'"
                        />
                        <button-spinner
                            class="mr-3 my-1"
                            v-else
                            :status="downloadStatus"
                        />
                        Dokument księgowy
                    </button>
                    <div
                        class="
                            notesTable-check
                            custom-checkbox-lg custom-control custom-checkbox
                            ml-3
                        "
                        :class="{
                            'billingType-checkbox': isBillingTypeSettlement
                        }"
                    >
                        <ui-checkbox-input
                            v-model="selectedSettlement"
                            :disabled="isDownloadDisabled"
                            :name="`settlement-${this.data.id}`"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { UiCheckboxInput } from '../global/ui'
import { DOCUMENT_TYPE_SUBTYPE_CONFIG, DOCUMENT_TYPE_SUBTYPE_SPLIT_DATE } from '@/store/modules/settlements.module'

export default {
    components: { UiCheckboxInput },
    props: {
        data: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            checkboxTest: false
        }
    },
    computed: {
        settlementStatus() {
            let status = ''

            if (!this.data.paid) {
                status = 'Nieopłacony'
            }
            if (this.data.paid) status = 'Opłacony'

            return status
        },
        downloadSettlementReportButtonTooltip() {
            let tooltip = null
            if (!this.data.ready_to_share_report) {
                tooltip = 'Raport rozliczeniowy jest w trakcie przygotowania'
            }
            return tooltip
        },
        downloadSettlementPdfButtonTooltip() {
            let tooltip = null
            if (!this.data.ready_to_share_document) {
                tooltip = 'Dokument jest w trakcie przygotowania'
            }
            return tooltip
        },
        downloadStatus() {
            return this.$store.getters.getActiveSettlement(this.data.id)
        },
        downloadStatusReport() {
            return this.$store.getters.getActiveSettlementReport(this.data.id)
        },
        selectedSettlement: {
            get() {
                return !!this.$store.getters.getSelectedSettlement(this.data.id)
            },
            set(value) {
                this.$store.dispatch('selectSettlement', {
                    id: this.data.id,
                    value
                })
                // if (value === false) {
                //     this.$store.dispatch('setSelectAllPromotions', false)
                // }
            }
        },
        isBillingTypeSettlement() {
            if (this.isMPSettlement) {
                return false
            }
            return this.data.parametrization.billing_type_id === 0
        },
        isAccountingNoteTypeSettlement() {
            return (
                this.data.parametrization.document_name_id === 5 ||
                this.data.parametrization.document_name_id === 6
            )
        },
        isMPSettlement() {
            return this.data.parametrization.external_crm_dict_service.code === 'ARCH'
        },
        setNipTooltipLabel() {
            const companyData = this.$store.getters.getUserCompaniesForSelect.find(
                e => e.value === this.data.nip
            )
            return companyData ? companyData.tooltipLabel : null
        },
        showSettlementDetails() {
            if (this.isMPSettlement) {
                return false
            }
            return this.isAccountingNoteTypeSettlement
                ? this.data.ready_to_share_document
                : true
        },
        setSettlementId() {
            if (this.isAccountingNoteTypeSettlement) {
                return `Nr rozliczenia: ${this.data.transfer_title
                    ?.split(' ')
                    .slice(-1)}`
            } else {
                return `Nr systemowy: ${this.data.id}`
            }
        },
        documentTypeName() {
            const { parametrization, sale_date } = this.data
            const documentTypeId = parametrization.document_name_id

            // Only document types that have subtypes
            const hasSubTypes = DOCUMENT_TYPE_SUBTYPE_CONFIG.some(
                cfg => cfg.apiId === documentTypeId
            )

            // No subtype logic or no sale date
            if (!hasSubTypes || !sale_date) {
                return parametrization.document_type_name
            }

            const saleDate = this.$moment(sale_date)

            // Main type
            if (saleDate.isBefore(DOCUMENT_TYPE_SUBTYPE_SPLIT_DATE)) {
                return parametrization.document_type_name
            }

            // Sub type
            const resolvedSubType = DOCUMENT_TYPE_SUBTYPE_CONFIG.find(
                cfg => cfg.isSubType && cfg.apiId === documentTypeId
            )

            return resolvedSubType?.label || parametrization.document_type_name
        },

        isDownloadDisabled() {
            return !this.data.ready_to_share_report && !this.data.ready_to_share_document
        }
    },
    methods: {
        downloadReport() {
            if (this.data.document_report && this.data.document_report.path) {
                this.$emit('settlementDownload', {
                    documentId: this.data.id,
                    type: 'report'
                })
            }
        },
        downloadPdf() {
            if (this.data.document_pdf && this.data.document_pdf.path) {
                this.$emit('settlementDownload', {
                    documentId: this.data.id,
                    type: 'note'
                })
            }
        }
    }
}
</script>
